import { type NotifyByEmailController } from "components/notifyStep/notifyByEmailController";
import { useRef, useState } from "react";

export const useNotifyStep = () => {
  const [notifyStepLoaded, setNotifyStepLoaded] = useState(false);
  const [notifyStepDataValid, setNotifyStepDataValid] = useState(false);
  const notifyControllerRef = useRef<NotifyByEmailController>();

  const onNotifyStepLoaded = (controller: NotifyByEmailController) => {
    notifyControllerRef.current = controller;
    setNotifyStepLoaded(true);
  };

  return {
    notifyControllerRef,
    notifyStepLoaded,
    notifyStepDataValid,
    setNotifyStepDataValid,
    onNotifyStepLoaded,
  };
};
